import { createCookie } from './cookie'

export const getSSOTokenCookieDomain = (env: string): string => {
  switch (env) {
    case 'production':
      return '.smarty.co.uk'
    case 'localhost':
      return 'localhost'
    default:
      return '.smarty.3.uk'
  }
}

export const createSsoCookie = ({
  name,
  ssoToken,
  env,
}: {
  name: string
  ssoToken: string
  env: string
}) => {
  createCookie({
    name,
    value: ssoToken,
    domain: getSSOTokenCookieDomain(env),
    isSecure: true,
  })
}
